export enum VendorOpportunityTabs {
  General = "general",
  Tasks = "tasks",
  Documents = "documents",
  Submissions = "submissions",
  Desking = "desking",
  CreditLine = "creditLine",
  Insurance = "insurance",
}
